const SahukariDetails = () => {
    return (
        <div className="container">
            <div className="card">
                <div className="card-body">
                    <p className="card-text">Sahukari is a web appltication to become a sahukari with our NBFC partners and disbursh your own loans to your customers.</p>
                </div>
                <a href="https://app.sahukari.com" target="_blank" rel="noopener noreferrer" className="btn btn-app m-2">Go to Sahukari <i className="bi bi-box-arrow-up-right"></i></a>
            </div>
        </div>
    );
};

export default SahukariDetails;